import angular from 'angular';
import tunnelComponent from './tunnel.component';
import TunnelService from './tunnel.service';
import tunnelConfig from './tunnel.config';

let tunnelModule = angular.module('app.tunnel',[])
  .component('tunnel', tunnelComponent)
  .service('TunnelService', TunnelService)
  .config(tunnelConfig);

export default tunnelModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/tunnel/tunnel.js
 **/